import React, { useEffect, useState } from "react";
import UsersServices from "../../../services/utilisateur/UsersService";
import useEntreprises from "../../../hooks/entreprise/useEntrepries";
import useUsers from "../../../hooks/utilisateur/useUsers";
import Loader from "../../components/loader";

const escapeHtml = (str) =>
  str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const HistoriqueClavier = () => {
  const [entreprises, setEntreprises] = useState([]);
  const { getAllEntreprises } = useEntreprises();
  const { getSuperviseurByEntrepriseId } = useUsers();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [texteSearch, setTexteSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  // Filtre horaire
  const [heureDebut, setHeureDebut] = useState("00:00");
  const [heureFin, setHeureFin] = useState("23:59");

  const [captures, setCaptures] = useState([]); // tableau { dateTaping, donneesClavier }
  const [loading, setLoading] = useState(false);
  const [captureSearched, setCaptureSearched] = useState(false);
  const [entrepriseSelected, setEntrepriseSelected] = useState("");
  const [superviseursParEntreprise, setSuperviseursParEntreprise] = useState(
    [],
  );
  const userData = JSON.parse(localStorage.getItem("user"));
  const [superviseursSelected, setSuperviseursSelected] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  // Toggle vue détail
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    getAllEntreprises()
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          setEntreprises(res.data.data);
        } else {
          console.error("La réponse de l'API n'est pas un tableau.");
        }
      })
      .catch((err) => console.error("Erreur API :", err));
  }, []);

  useEffect(() => {
    setCaptures([]);
    setCaptureSearched(false);
    setShowDetail(false);
  }, [selectedUser, selectedDate, heureDebut, heureFin]);

  const resetFilter = () => {
    setSelectedUser("");
    setSelectedDate("");
    setHeureDebut("00:00");
    setHeureFin("23:59");
  };

  useEffect(() => {
    if (!userData) return;
    if (userData.role === 1) {
      if (entreprises.length > 0 && !entrepriseSelected) {
        setEntrepriseSelected(entreprises[0]._id);
      }
    } else {
      setEntrepriseSelected(userData.entreprise);
      setSuperviseursSelected([userData._id]);
    }
  }, [entreprises, entrepriseSelected]);

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const response = await UsersServices.getAll();
        const usersRole3 = response.data.data.filter((user) => user.role === 3);
        setUsers(usersRole3);
      } catch (error) {
        console.error("Erreur lors de la récupération des utilisateurs", error);
      }
    };
    fetchAllUsers();
  }, []);

  useEffect(() => {
    if (!userData) return;
    if (userData.role === 1) {
      if (entrepriseSelected) {
        getSuperviseurByEntrepriseId(entrepriseSelected, (data) => {
          setSuperviseursParEntreprise(data || []);
        });
      } else {
        setSuperviseursParEntreprise([]);
      }
    }
  }, [entrepriseSelected]);

  useEffect(() => {
    const filtered = users.filter((user) => {
      const isFromEntreprise = user?.entreprise?._id === entrepriseSelected;
      const isSuperviseurOK =
        superviseursSelected.length === 0 ||
        (user.gerant &&
          user.gerant.some((gId) => superviseursSelected.includes(gId)));
      return isFromEntreprise && isSuperviseurOK;
    });
    setFilteredUsers(filtered);
  }, [users, entrepriseSelected, superviseursSelected]);

  const fetchCaptures = async () => {
    if (!selectedUser || !selectedDate) {
      console.warn("Tous les champs ne sont pas remplis");
      return;
    }

    const dateParts = selectedDate.split("-");
    const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    const dateHour = `${formattedDate}_${heureDebut}_${heureFin}`;

    setLoading(true);
    try {
      const response = await UsersServices.getHistoriqueByDateTime(
        selectedUser,
        dateHour,
      );
      const donnees = response.data?.data?.historique?.donnees;

      if (Array.isArray(donnees) && donnees.length > 0) {
        setCaptures(donnees);
        setCaptureSearched(false);
        setShowDetail(false); // on repart toujours sur la vue simple
      } else {
        setCaptures([]);
        setCaptureSearched(true);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des captures clavier",
        error,
      );
      setCaptures([]);
      setCaptureSearched(true);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchCaptures();
  };

  const highlightText = (text, query) => {
    const safeText = escapeHtml(text || "");
    if (!query) return safeText;
    const safeQuery = escapeRegExp(query);
    const regex = new RegExp(`(${safeQuery})`, "gi");
    return safeText.replace(
      regex,
      '<span style="color: blue; text-decoration: underline; background-color: #ffff99;">$1</span>',
    );
  };

  const formatHeure = (isoDate) => {
    try {
      return new Date(isoDate).toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch {
      return "--:--:--";
    }
  };

  // Vue simple "comme avant" : tout le texte de la plage concaténé en un seul bloc
  const texteConcatene = captures
    .map((entry) => entry.donneesClavier)
    .filter(Boolean)
    .join(" ");

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="h4 mb-0">Historiques clavier</h2>
      </div>

      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h3 className="h6 mb-0">Filtrer les captures clavier</h3>
        </div>

        <div className="card-body">
          <form onSubmit={handleFilterSubmit}>
            <div className="row g-3">
              {userData?.role === 1 && (
                <>
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small">
                      Entreprise
                    </label>
                    <select
                      className="form-select"
                      value={entrepriseSelected}
                      onChange={(e) => setEntrepriseSelected(e.target.value)}
                      required
                    >
                      {entreprises.map((ent) => (
                        <option key={ent._id} value={ent._id}>
                          {ent.nom}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small">
                      Superviseurs
                    </label>
                    <div
                      className="border rounded-3 px-2 py-2"
                      style={{
                        minHeight: "45px",
                        maxHeight: "150px",
                        overflowY: "auto",
                        backgroundColor: entrepriseSelected
                          ? "#fff"
                          : "#f8f9fa",
                        cursor: entrepriseSelected ? "default" : "not-allowed",
                      }}
                    >
                      {superviseursParEntreprise.length > 0 ? (
                        superviseursParEntreprise.map((sup) => (
                          <div key={sup._id} className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`sup-${sup._id}`}
                              value={sup._id}
                              disabled={!entrepriseSelected}
                              checked={superviseursSelected.includes(sup._id)}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSuperviseursSelected((prev) =>
                                  checked
                                    ? [...prev, sup._id]
                                    : prev.filter((id) => id !== sup._id),
                                );
                              }}
                            />
                            <label
                              className="form-check-label ms-1"
                              htmlFor={`sup-${sup._id}`}
                            >
                              {sup.nom}
                            </label>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted mb-0 small">
                          Aucun superviseur disponible
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="col-12 col-md-6">
                <label htmlFor="user" className="form-label fw-semibold small">
                  Utilisateur
                </label>
                <select
                  id="user"
                  className="form-select"
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                  required
                >
                  <option value="">Sélectionner un utilisateur</option>
                  {filteredUsers.length === 0 && (
                    <option disabled>Aucun utilisateur trouvé</option>
                  )}
                  {filteredUsers.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.nom} {user.prenom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="date" className="form-label fw-semibold small">
                  Date
                </label>
                <input
                  type="date"
                  id="date"
                  className="form-control"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  required
                />
              </div>

              <div className="col-6 col-md-3">
                <label
                  htmlFor="heureDebut"
                  className="form-label fw-semibold small"
                >
                  Heure début
                </label>
                <input
                  type="time"
                  id="heureDebut"
                  className="form-control"
                  value={heureDebut}
                  onChange={(e) => setHeureDebut(e.target.value)}
                />
              </div>

              <div className="col-6 col-md-3">
                <label
                  htmlFor="heureFin"
                  className="form-label fw-semibold small"
                >
                  Heure fin
                </label>
                <input
                  type="time"
                  id="heureFin"
                  className="form-control"
                  value={heureFin}
                  onChange={(e) => setHeureFin(e.target.value)}
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-4">
              <button
                type="button"
                className="btn btn-outline-danger flex-fill"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  resetFilter();
                }}
              >
                Réinitialiser
              </button>
              <button type="submit" className="btn btn-primary flex-fill">
                Filtrer
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* RESULTATS */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          {loading ? (
            <Loader />
          ) : captures && captures.length > 0 ? (
            <>
              <div className="d-flex align-items-end justify-content-between flex-wrap gap-2 mb-3">
                <div style={{ maxWidth: "320px", flex: 1 }}>
                  <label className="form-label fw-semibold small">
                    Rechercher un texte
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={texteSearch}
                    onChange={(e) => setTexteSearch(e.target.value)}
                    placeholder="Mot-clé à rechercher..."
                  />
                </div>

                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => setShowDetail((prev) => !prev)}
                >
                  <i
                    className={`fas ${showDetail ? "fa-eye-slash" : "fa-list"} me-1`}
                  />
                  {showDetail ? "Masquer le détail" : "Détail"}
                </button>
              </div>

              {!showDetail ? (
                // Vue simple : texte continu, comme avant
                <div
                  className="border rounded-3 p-3 bg-light"
                  style={{
                    width: "100%",
                    maxHeight: "40vh",
                    overflowY: "auto",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: highlightText(texteConcatene, texteSearch),
                  }}
                />
              ) : (
                // Vue détaillée : chaque entrée avec son heure précise
                <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                  {captures.map((entry, idx) => (
                    <div
                      key={idx}
                      className="mb-2 border rounded-3 p-2 bg-light"
                    >
                      <div className="small text-muted mb-1">
                        <i className="fas fa-clock me-1" />
                        {formatHeure(entry.dateTaping)}
                      </div>
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: highlightText(
                            entry.donneesClavier,
                            texteSearch,
                          ),
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            captureSearched && (
              <div className="text-center py-4">
                <p style={{ color: "#ff6f61", fontSize: "18px" }}>
                  <i
                    className="fas fa-image-slash"
                    style={{ fontSize: "24px", marginRight: "10px" }}
                  />
                  Désolé, aucune capture de clavier trouvée pour cet
                  utilisateur, cette date et cette plage horaire.
                </p>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoriqueClavier;
